import { jsx as _jsx } from "react/jsx-runtime";
import { LogoutOutlined } from "@ant-design/icons";
import { App, Button } from "antd";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "../../../others/i18n.js";
import { useStores } from "../../../store/root.js";
import { confirmLogout } from "../../../util/session.js";
const RcbLogoutButton = ()=>{
    const app = App.useApp();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { rcbAuthenticationStore } = useStores();
    return /*#__PURE__*/ _jsx(Button, {
        type: "primary",
        icon: /*#__PURE__*/ _jsx(LogoutOutlined, {}),
        title: t("Logout"),
        onClick: ()=>confirmLogout(t, rcbAuthenticationStore, navigate, app),
        children: t("Logout")
    });
};
export { RcbLogoutButton };
